import { render } from "./InstructorList.vue?vue&type=template&id=8c7590c6"
import script from "./InstructorList.vue?vue&type=script&lang=js"
export * from "./InstructorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__